module.exports = __webpack_public_path__ + "static/travel-vaccination-a962615d159c60b227c6b05f08c23714.png";